// extracted by mini-css-extract-plugin
export var measureBox = "_8t-0";